import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/apiClient";
import type { DashboardDataResponse } from "@/types/dashboard";

export const dashboardKeys = {
  details: (isDashboardBusinessFilter: boolean, businessName: string | null) =>
    ["dashboard", "details", isDashboardBusinessFilter, businessName] as const,
  businesses: () => ["dashboard", "businesses"] as const
};

export function useDashboardData(
  isDashboardBusinessFilter: boolean,
  businessName: string | null
) {
  return useQuery({
    queryKey: dashboardKeys.details(isDashboardBusinessFilter, businessName),
    queryFn: () => {
      const path =
        businessName != null
          ? `Dashboard/dashboard/${isDashboardBusinessFilter}/${encodeURIComponent(businessName)}`
          : `Dashboard/dashboard/${isDashboardBusinessFilter}`;
      return apiFetch<DashboardDataResponse>(path);
    },
    placeholderData: (previousData) => previousData,
    staleTime: 60_000,
    refetchOnMount: "always"
  });
}

export function useBusinesses() {
  return useQuery({
    queryKey: dashboardKeys.businesses(),
    queryFn: () =>
      apiFetch<Record<string, string[]>>("Business/GetBusinessAndBusinessLineTypes"),
    staleTime: 5 * 60_000,
    refetchOnMount: "always"
  });
}
